import { OrderItemDataFragment, Enum_Orderitemaction_Action } from "data";
import { PowerOnIcon } from "components/Icons";
import {
  ActionComponent,
  ActionComponentVariant,
} from "components/ActionComponent";
import { useRegisterOrderItemAction } from "features/order-items/data/hooks/order-item-actions";

interface ReplacePSUActionProps {
  orderItem: OrderItemDataFragment;
  variant: ActionComponentVariant;
}

export const ReplacePSUAction = (props: ReplacePSUActionProps) => {
  const { orderItem, variant } = props;
  const { registerAction } = useRegisterOrderItemAction();
  return (
    <ActionComponent
      action={async () => {
        if (orderItem.id) {
          await registerAction({
            orderItem,
            action: {
              action: Enum_Orderitemaction_Action.ReplacePsu,
            },
          });
        }
      }}
      variant={variant}
      actionIcon={<PowerOnIcon />}
      actionLabel="Replace PSU"
      data-cy="action-replace-psu"
    />
  );
};

ReplacePSUAction.defaultProps = {
  variant: "menu-item",
};
